// extracted by mini-css-extract-plugin
export default {"emptyState":"fill-history-services_emptyState__qHaNl","emptyIcon":"fill-history-services_emptyIcon__pAk3g"};